import { render, staticRenderFns } from "./AllLeaves.vue?vue&type=template&id=b1f64858&scoped=true"
import script from "./AllLeaves.vue?vue&type=script&lang=js"
export * from "./AllLeaves.vue?vue&type=script&lang=js"
import style0 from "./AllLeaves.vue?vue&type=style&index=0&id=b1f64858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f64858",
  null
  
)

export default component.exports